module.exports = ":host.ng-dirty.ng-invalid>span>.input{border-color:#E17576}.input.custom-input{width:calc(100% - 16px);margin-right:2px}\n"